import { create } from 'zustand'
import { BASE_URL } from '../api/api'

export const NewsStore = create((set) => ({
  news: [],
  newsDetails: {},
  totalPages: 1,
  authorNews: {},
  loading: false,
  error: null,
  banners: [],
  latestNews: [],
  notifications: [],
  notificationLoading: false,
  hasMoreNotifications: true,

  // Get Banners
  fetchBanners: async () => {
    try {
      const res = await fetch(`${BASE_URL}api/banners/`, {
        method: "GET",
        // headers: {
        //   "ngrok-skip-browser-warning": "true",
        //   "Accept": "application/json",
        // },
      });

      if (!res.ok) throw new Error("Failed to fetch banners");

      const data = await res.json();

      set({
        banners: data?.data || data || [],
      });
    } catch (err) {
      console.error("Error fetching banners:", err);
    }
  },

  // Get Latest News List
  fetchLatestNews: async (limit = 10) => {
    try {
      set({ loading: true, error: null });

      const res = await fetch(`${BASE_URL}api/latest-news?limit=${limit}`, {
        method: "GET",
        headers: {
          "ngrok-skip-browser-warning": "true",
          "Accept": "application/json",
        },
      });

      if (!res.ok) throw new Error("Failed to fetch latest news");

      const data = await res.json();

      set({
        latestNews: data?.data || [],
        loading: false,
      });
    } catch (err) {
      set({
        error: err.message,
        loading: false,
      });
    }
  },

  // Get News List
fetchNews: async (page = 1, limit = 10, search = "", category = "") => {
  try {
    set({ loading: true, error: null });

    const params = new URLSearchParams({
      page,
      limit,
      search: search || "",
      category: category || "",
    }).toString();

    const res = await fetch(`${BASE_URL}api/all-news?${params}`, {
      method: "GET",
      headers: {
        "ngrok-skip-browser-warning": "true",
        "Accept": "application/json",
      },
    });

    if (!res.ok) throw new Error("Failed to fetch news");

    const data = await res.json();

    set({
      news: data?.data || [],
      totalPages:
        data?.meta?.last_page ||
        data?.last_page ||
        Math.ceil((data?.total || 0) / limit) ||
        1,
      loading: false,
    });
  } catch (err) {
    set({
      error: err.message,
      loading: false,
    });
  }
},

  // Get News Details By Slug
fetchNewsDetails: async (slug) => {
  try {
    set({ loading: true, error: null });

    const res = await fetch(
      `${BASE_URL}api/news-details/${slug}`,
      {
        method: "GET",
        // headers: {
        //   "ngrok-skip-browser-warning": "true",
        //   "Accept": "application/json",
        // },
      }
    );

    if (!res.ok) throw new Error("Failed to fetch news details");

    const data = await res.json();

    set({
      newsDetails: data,
      loading: false,
    });
  } catch (err) {
    set({
      error: err.message,
      loading: false,
    });
  }
},

  // Get News By Author
  fetchNewsByAuthor: async (id, page = 1, limit = 10) => {
    try {
      set({ loading: true, error: null })

      const res = await fetch(
        `${BASE_URL}api/all-news/${id}?page=${page}&limit=${limit}`,
        {
          method: 'GET',
        }
      )

      if (!res.ok) throw new Error('Failed to fetch author news')

      const data = await res.json()

      set({
        authorNews: data,
        loading: false,
      })
    } catch (err) {
      set({
        error: err.message,
        loading: false,
      })
    }
  },

  // Get Notifications (Latest News)
  fetchNotifications: async (page = 1, limit = 10) => {
    try {
      set({ notificationLoading: true })

      const res = await fetch(
        `${BASE_URL}api/all-news?page=${page}&limit=${limit}`,
        {
          method: 'GET',
        }
      )

      if (!res.ok) throw new Error('Failed to fetch notifications')

      const data = await res.json()
      const newItems = data?.data || []

      set((state) => ({
        notifications: page === 1 ? newItems : [...state.notifications, ...newItems],
        notificationLoading: false,
        hasMoreNotifications: newItems.length >= limit,
      }))
    } catch (err) {
      set({ notificationLoading: false })
    }
  },
}))
